/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanRevision: core.serialization.ObjectSchema<
    serializers.LessThanRevision.Raw,
    Truvity.LessThanRevision
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanRevision {
    export interface Raw {
        value: number;
    }
}
